import React from 'react';
import TreeFilter from './TreeFilter';

export interface ItemProvider {
    id: number;
    name: string;
    providers?: ItemProvider[];
}

interface ItemProviderFilterProps {
    value: number[];
    onChange: (value: number[]) => void;
    providers: ItemProvider[];
    maxDepth?: number;
}

export const ItemProviderFilter: React.FC<ItemProviderFilterProps> = ({ providers, value, onChange, maxDepth }) => {
    return (
        <div>
            <TreeFilter
                data={providers}
                value={(value || []).map((x) => +x)}
                idField="id"
                nameField="name"
                childrenField="providers"
                onChange={onChange}
                maxDepth={maxDepth}
            />
        </div>
    );
};

export default ItemProviderFilter;

